module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraLightItalic.43d12d16.eot";